import { ReactNode } from "react";

interface FilterWrapperProps {
  label: string;
  children: ReactNode;
}

export const FilterWrapper: React.FC<FilterWrapperProps> = ({ label, children }) => {
  return (
    <div className="flex flex-col p-4 border border-gray-200 rounded-lg bg-white w-full">
      <label className="text-sm font-medium">{label}</label>
      {children}
    </div>
  );
};
